import { NestedTreeControl } from '@angular/cdk/tree';
import {
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseChartDirective } from 'ng2-charts';
import * as _moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PlantGroupElement } from 'src/app/models/O3AdministrationModels/plant-model';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { Chart } from 'angular-highcharts';
import { Options } from 'highcharts';
import * as Highcharts from 'highcharts';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CrewScheduleService } from 'src/app/services/crewSchedule.service';
import { Multilingual } from 'src/app/services/multilingual';
const moment = _moment;
@Component({
  selector: 'app-oee-dashboard',
  templateUrl: './oee-dashboard.component.html',
  styleUrls: ['./oee-dashboard.component.scss'],
})
export class OeeDashboardComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart!: BaseChartDirective;
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  treeControl = new NestedTreeControl<PlantGroupElement>(
    (node) => node.children
  );
  plantGroupSource = new MatTreeNestedDataSource<PlantGroupElement>();
  hasChild = (_: number, node: PlantGroupElement) =>
    !!node.children && node.children.length > 0;
  oeeDashboardForm!: FormGroup;
  params: any;
  oeeAnalysis = {
    barType: 'radial',
    color: '#10CE9C',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#09608c',
      },
    },
  };
  capacityUtilizationAnalysis = {
    barType: 'radial',
    color: '#3AAFE4',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#09608c',
      },
    },
  };
  availabilityAnalysis = {
    barType: 'radial',
    color: '#F85439',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#F85439',
      },
    },
  };
  performanceAnalysis = {
    barType: 'radial',
    color: '#3AAFE4',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#09608c',
      },
    },
  };

  qualityAnalysis = {
    barType: 'radial',
    color: '#F85439',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#F85439',
      },
    },
  };
  // iconUrl
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  menuBlueIconUrl = 'assets/images/menu-bottom-blue-icon.png';

  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  public date: moment.Moment | undefined;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  unitList!: any[];
  OeeDashboardData!: any;
  isproductionDBModel = false;
  isPopupMachine = false;
  isPlantGroupModelVisible = false;
  UnitName: string | undefined;
  CUPerc!: any;
  GrossProduce!: any;
  AvailableHours!: any;
  PlannedHours!: any;
  RunningHourse!: any;
  Waste!: any;
  ShutdownHours!: any;
  idealProduction!: any;
  grossProduction!: any;
  netProduction!: any;
  wasteKG!: any;
  PlannedDowntime!: any;
  UnplannedDowntime!: any;
  totalPlannedDowntime!: any;
  monthlyOeeLabel: any[] = new Array();
  monthlyOeeData: any[] = new Array();
  monthlyOutputLabel: any[] = new Array();
  monthlyOutputData: any[] = new Array();
  chartOutputLossData: any[] = new Array();
  chartOutputLossWaterfall!: any;
  chartMonthlyOutput!: Chart;
  chartMonthlyOeeTrend!: Chart;
  chartMonthlyOeeDrill!: Chart;
  options: any;
  activeButton!: any;
  OEEDatasource!: MatTableDataSource<any>;
  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridApiEdit: any;
  gridColumnApi: any;
  gridColumnApiEdit: any;
  key: any;
  OutputLoses!: any;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  window: any;
  crewScheduleList: any;
  gridOptions: any = {
    defaultColDef: {
      rowModelType: 'infinite',
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- & HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    // floatingFilter: true,
  };
  lang: any;
  hasQueryParams: boolean;
  firstRender: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    private kpiMaster: KpimasterService,
    private toaster: ToastrService,
    private usermanagementService: UserManagementService,
    private productivityservice: ProductivityService,
    private spinner: NgxSpinnerService,
    public router: Router,
    private translater: TranslaterService,
    private translate: TranslateService,
    private crewService: CrewScheduleService,
    private route: ActivatedRoute
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();});
    this.columnDefs = [
      {
        headerName: 'Date',
        field: 'DATE',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Start time',
        field: 'StartTime',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'End time',
        field: 'EndTime',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Plant',
        field: 'pl_desc',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Machine',
        field: 'pu_desc',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Production start time',
        field: 'PSStartTime',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Production end time',
        field: 'PSEndTime',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Gross Produce',
        field: 'GrossProduce',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Ideal Produce',
        field: 'IdealProduce',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return params.value !== null ? params.value.toFixed(2) : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Waste',
        field: 'waste',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return params.value !== null ? params.value.toFixed(2) : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Target speed(hours)',
        field: 'TargetSpeed',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Runtime',
        field: 'RunTime',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return params.value.toFixed(2);
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Downtime',
        field: 'Downtime',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return params.value.toFixed(2);
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Time Lost',
        field: 'TimeLost',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Process order',
        field: 'ProcessOrder',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'PPD Description',
        field: 'PPD_Desc',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Planned start date',
        field: 'PlannedStartDate',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Planned end date',
        field: 'PlannedEndDate',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Target quantity',
        field: 'TargetQuantity',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Item description',
        field: 'ItemDesc',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];
  }

  ngOnInit(): void {
    localStorage.setItem('O3RightMenuId', '79')

    this.params = JSON.parse(localStorage.getItem('OEEDashboard'));
    if (this.params) {
      this.hasQueryParams = true;
    }
    this.initForm();
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.datasource();
    localStorage.removeItem('OEEDashboard');
  }
  initForm() {
    const dateStart = new Date();
    //dateStart.setDate(dateStart.getDate() - 183);
    dateStart.setHours(6);
    dateStart.setMinutes(0);
    dateStart.setSeconds(0);

    const dateEnd = new Date();
    dateEnd.setDate(dateEnd.getDate());

    this.oeeDashboardForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [dateStart, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      shift: ['', []],
      searchval: [''],
    });
  }

  onChangeGroup(data: any): void {
    this.getPlants(data);
  }
  onChangeLine(data: any): void {
    this.getUnit(data.value);
  }
  onChangePlant(data: any): void {
    this.getLine(data.value);
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        // this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  datasource(): void {
    const key = {
      UserId: 206, //later it will be change this is only for testing
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList.length > 0) {
          id.value = data.lstEG[0].EG_Id;
          // this.oeeDashboardForm
          //   .get('UserGroup1')
          //   ?.setValue(data.lstEG[0].EG_Id);
          // this.oeeDashboardForm
          //   .get('UserPlant1')
          //   ?.setValue(data.lstEG[0].EG_Id);
          if (this.hasQueryParams && this.firstRender) {
            this.oeeDashboardForm
              .get('UserGroup1')
              ?.setValue(parseInt(this.params.UserGroup1));
          } else {
            this.oeeDashboardForm.patchValue({
              UserGroup1: data.lstEG[0].EG_Id,
              UserPlant1: data.lstEG[0].EG_Id,
            });
          }
          this.filteredGroups = this.GroupList.slice();

          // if (this.hasQueryParams) {
          //   this.getQueryParamsAndSetDate();
          // } else {
          //   this.setStartAndEndDate(stDT, edDT);
          // }
          this.getPlants(id);
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  getPlants(event: any): void {
    const key = {
      EG_ID: this.oeeDashboardForm.value.UserGroup1,
      userId: 206,
    };
    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList1 = data.lstPlant;
        if (this.PlantList1.length > 0) {
          const id = data.lstPlant[0].PT_Id;
          if (this.hasQueryParams && this.firstRender) {
            this.oeeDashboardForm
              .get('UserPlant1')
              ?.patchValue(parseInt(this.params.UserPlant1));
          } else {
            this.oeeDashboardForm.get('UserPlant1')?.patchValue(id);
          }
          this.getLine(id);

          this.filteredPlants = this.PlantList1.slice();
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getLine(id: any) {
    const key = {
      PT_ID: this.oeeDashboardForm.value.UserPlant1,
      userId: 206,
    };

    this.productivityservice.getLineData(key).subscribe(
      (data: any) => {
        this.lineList = data.lstLine;
        if (this.lineList.length > 0) {
          const lineDefault = this.lineList[0];
          if (this.hasQueryParams && this.firstRender) {
            this.oeeDashboardForm
              .get('line')
              ?.setValue(parseInt(this.params.line));
          } else {
            this.oeeDashboardForm.controls.line.patchValue(lineDefault.PL_Id);
          }
          this.filteredLines = this.lineList.slice();
          this.getUnit(lineDefault.PL_Id);
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getUnit(id: number) {
    const key = {
      PL_ID: this.oeeDashboardForm.value.line,
      userId: 206,
    };

    this.productivityservice.getUnitData(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
        if (this.unitList.length > 0) {
          const unitDefault = this.unitList[0];
          if (this.hasQueryParams && this.firstRender) {
            this.oeeDashboardForm
              .get('unit')
              ?.setValue(parseInt(this.params.UnitId));
          } else {
            this.oeeDashboardForm.controls.unit.patchValue(unitDefault.PU_Id);
          }
          this.filteredUnits = this.unitList.slice();
        }
        // this.onSubmit();
        this.constructData_CS();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  onSubmit(): void {
    this.makeData();
    this.getOeeDashboard();
  }

  today(): void {
    this.constructData_CS();
  }

  yesterday(): void {
    this.constructData_LS();
  }

  yesterdayFullDay(): void {
    this.constructData_1D();
  }

  lastWeek(): void {
    this.constructData_1W();
  }

  lastMonth(): void {
    this.constructData_1M();
  }

  constructData_CS(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);
    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.oeeDashboardForm.get('dateStart')?.patchValue(stDT);
    this.oeeDashboardForm.get('dateEnd')?.patchValue(edDT);
    this.getShiftDates_CS();
  }

  constructData_LS(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.oeeDashboardForm.get('dateStart')?.patchValue(stDT);
    this.oeeDashboardForm.get('dateEnd')?.patchValue(edDT);
    this.getShiftDates_LS();
  }

  constructData_1D(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.oeeDashboardForm.get('dateStart')?.patchValue(stDT);
    this.oeeDashboardForm.get('dateEnd')?.patchValue(edDT);

    this.getShiftDates_1D();
  }

  constructData_1W(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 6);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.oeeDashboardForm.get('dateStart')?.patchValue(stDT);
    this.oeeDashboardForm.get('dateEnd')?.patchValue(edDT);
    this.getShiftDates_1W();
  }

  constructData_1M(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 29);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.oeeDashboardForm.get('dateStart')?.patchValue(stDT);
    this.oeeDashboardForm.get('dateEnd')?.patchValue(edDT);
    this.getShiftDates_1M();
  }

  getShiftDates_CS(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());

    const key = {
      PUID: this.oeeDashboardForm.value.unit,
      Date: stDT,
    };

    this.crewService.GetCrewScheduleData(key).subscribe((res: any) => {
      this.crewScheduleList = res.CrewScheduleList;
      const date = new Date();
      // tslint:disable-next-line:max-line-length
      const record = this.crewScheduleList.filter(
        (c: any) =>
          date.getTime() >= new Date(c.ShiftStart).getTime() &&
          date.getTime() <= new Date(c.ShiftEnd).getTime()
      );

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime

        if (this.hasQueryParams && this.firstRender) {
          this.oeeDashboardForm.controls.dateStart.patchValue(
            new Date(this.params.dateStart)
          );
          this.oeeDashboardForm.controls.dateEnd.patchValue(
            new Date(this.params.dateEnd)
          );

          this.key = {
            dtStartDate: new Date(this.params.dateStart),
            dtEndDate: new Date(this.params.dateEnd),
            GroupId: this.params.UserGroup1,
            PlantId: this.params.UserPlant1,
            UnitId: this.params.unit,
            LineId: this.params.line,
            shift: '*',
          };
          this.firstRender = false;
        } else {
          const endDT = new Date();
          endDT.setDate(endDT.getDate());
          const stDT = record[0].ShiftStart;
          this.oeeDashboardForm.controls.dateStart.patchValue(stDT);
          this.oeeDashboardForm.controls.dateEnd.patchValue(endDT);
          this.key = {
            dtStartDate: this.oeeDashboardForm.value.dateStart,
            dtEndDate: this.oeeDashboardForm.value.dateEnd,
            GroupId: this.oeeDashboardForm.value.UserGroup1,
            PlantId: this.oeeDashboardForm.value.UserPlant1,
            UnitId: this.oeeDashboardForm.value.unit,
            LineId: this.oeeDashboardForm.value.line,
            shift: '*',
          };
        }

        this.getOeeDashboard();
      } else {
        this.key = {
          dtStartDate: this.oeeDashboardForm.value.dateStart,
          dtEndDate: this.oeeDashboardForm.value.dateEnd,
          GroupId: this.oeeDashboardForm.value.UserGroup1,
          PlantId: this.oeeDashboardForm.value.UserPlant1,
          UnitId: this.oeeDashboardForm.value.unit,
          LineId: this.oeeDashboardForm.value.line,
          shift: '*',
        };
        this.getOeeDashboard();
      }
    });
  }
  getShiftDates_LS(): void {
    const lastshifttDT = new Date();
    lastshifttDT.setDate(lastshifttDT.getDate());
    lastshifttDT.setHours(lastshifttDT.getHours() - 12);
    lastshifttDT.setMinutes(0);
    lastshifttDT.setSeconds(0);

    const key = {
      PUID: this.oeeDashboardForm.value.unit,
      Date: lastshifttDT,
    };

    this.crewService.GetCrewScheduleData(key).subscribe((res: any) => {
      this.crewScheduleList = res.CrewScheduleList;
      // tslint:disable-next-line:max-line-length
      const record = this.crewScheduleList.filter(
        (c: any) =>
          lastshifttDT.getTime() >= new Date(c.ShiftStart).getTime() &&
          lastshifttDT.getTime() <= new Date(c.ShiftEnd).getTime()
      );

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime
        this.oeeDashboardForm
          .get('dateStart')
          ?.patchValue(record[0].ShiftStart);
        this.oeeDashboardForm.get('dateEnd')?.patchValue(record[0].ShiftEnd);
        this.key = {
          dtStartDate: this.oeeDashboardForm.value.dateStart,
          dtEndDate: this.oeeDashboardForm.value.dateEnd,
          GroupId: this.oeeDashboardForm.value.UserGroup1,
          PlantId: this.oeeDashboardForm.value.UserPlant1,
          UnitId: this.oeeDashboardForm.value.unit,
          LineId: this.oeeDashboardForm.value.line,
          shift: '*',
        };
        this.getOeeDashboard();
      } else {
        this.key = {
          dtStartDate: this.oeeDashboardForm.value.dateStart,
          dtEndDate: this.oeeDashboardForm.value.dateEnd,
          GroupId: this.oeeDashboardForm.value.UserGroup1,
          PlantId: this.oeeDashboardForm.value.UserPlant1,
          UnitId: this.oeeDashboardForm.value.unit,
          LineId: this.oeeDashboardForm.value.line,
          shift: '*',
        };
        this.getOeeDashboard();
      }
    });
  }

  getShiftDates_1D(): void {
    const lastshifttDT = new Date();
    lastshifttDT.setDate(lastshifttDT.getDate() - 1);

    const key = {
      PUID: this.oeeDashboardForm.value.unit,
      Date: lastshifttDT,
    };

    this.crewService.GetCrewScheduleData(key).subscribe((res: any) => {
      this.crewScheduleList = res.CrewScheduleList;
      const record = this.crewScheduleList;

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime
        this.oeeDashboardForm
          .get('dateStart')
          ?.patchValue(record[0].ShiftStart);
        this.oeeDashboardForm.get('dateEnd')?.patchValue(record[1].ShiftEnd);
        this.key = {
          dtStartDate: this.oeeDashboardForm.value.dateStart,
          dtEndDate: this.oeeDashboardForm.value.dateEnd,
          GroupId: this.oeeDashboardForm.value.UserGroup1,
          PlantId: this.oeeDashboardForm.value.UserPlant1,
          UnitId: this.oeeDashboardForm.value.unit,
          LineId: this.oeeDashboardForm.value.line,
          shift: '*',
        };
        this.getOeeDashboard();
      } else {
        this.key = {
          dtStartDate: this.oeeDashboardForm.value.dateStart,
          dtEndDate: this.oeeDashboardForm.value.dateEnd,
          GroupId: this.oeeDashboardForm.value.UserGroup1,
          PlantId: this.oeeDashboardForm.value.UserPlant1,
          UnitId: this.oeeDashboardForm.value.unit,
          LineId: this.oeeDashboardForm.value.line,
          shift: '*',
        };
        this.getOeeDashboard();
      }
    });
  }

  getShiftDates_1W(): void {
    const lastshifttDT = new Date();
    lastshifttDT.setDate(lastshifttDT.getDate() - 7);

    const key = {
      PUID: this.oeeDashboardForm.value.unit,
      Date: lastshifttDT,
    };

    this.crewService.GetCrewScheduleData(key).subscribe((res: any) => {
      this.crewScheduleList = res.CrewScheduleList;
      const record = this.crewScheduleList;

      // tslint:disable-next-line:max-line-length
      // const record = this.crewScheduleList.filter(
      //   (c: any) =>
      //     lastshifttDT.getTime() >= new Date(c.ShiftStart).getTime() &&
      //     lastshifttDT.getTime() <= new Date(c.ShiftEnd).getTime()
      // );

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime
        // const endDT = new Date();
        // endDT.setDate(endDT.getDate());
        // this.oeeDashboardForm
        //   .get('dateStart')
        //   ?.patchValue(record[0].ShiftStart);
        // this.oeeDashboardForm.get('dateEnd')?.patchValue(endDT);        

        this.oeeDashboardForm
          .get('dateStart')
          ?.patchValue(record[0].ShiftStart);


          const lastshifttDT = new Date();
          lastshifttDT.setDate(lastshifttDT.getDate() - 1);

          const key = {
            PUID: this.oeeDashboardForm.value.unit,
            Date: (lastshifttDT),
          };
      
          this.crewService.GetCrewScheduleData(key).subscribe((res: any) => {
            this.crewScheduleList = res.CrewScheduleList;
            const record = this.crewScheduleList;

            if (record.length>1)
            {
              this.oeeDashboardForm.get('dateEnd')?.patchValue(record[1].ShiftEnd);
            }

          });
        

        this.key = {
          dtStartDate: this.oeeDashboardForm.value.dateStart,
          dtEndDate: this.oeeDashboardForm.value.dateEnd,
          GroupId: this.oeeDashboardForm.value.UserGroup1,
          PlantId: this.oeeDashboardForm.value.UserPlant1,
          UnitId: this.oeeDashboardForm.value.unit,
          LineId: this.oeeDashboardForm.value.line,
          shift: '*',
        };
        this.getOeeDashboard();
      } else {
        this.key = {
          dtStartDate: this.oeeDashboardForm.value.dateStart,
          dtEndDate: this.oeeDashboardForm.value.dateEnd,
          GroupId: this.oeeDashboardForm.value.UserGroup1,
          PlantId: this.oeeDashboardForm.value.UserPlant1,
          UnitId: this.oeeDashboardForm.value.unit,
          LineId: this.oeeDashboardForm.value.line,
          shift: '*',
        };
        this.getOeeDashboard();
      }
    });
  }

  getShiftDates_1M(): void {
    const lastshifttDT = new Date();
    lastshifttDT.setDate(lastshifttDT.getDate() - 30);

    const key = {
      PUID: this.oeeDashboardForm.value.unit,
      Date: lastshifttDT,
    };

    this.crewService.GetCrewScheduleData(key).subscribe((res: any) => {
      this.crewScheduleList = res.CrewScheduleList;
      const record = this.crewScheduleList;

      // tslint:disable-next-line:max-line-length
      // const record = this.crewScheduleList.filter(
      //   (c: any) =>
      //     lastshifttDT.getTime() >= new Date(c.ShiftStart).getTime() &&
      //     lastshifttDT.getTime() <= new Date(c.ShiftEnd).getTime()
      // );

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime
        // const endDT = new Date();
        // endDT.setDate(endDT.getDate());
        // this.oeeDashboardForm
        //   .get('dateStart')
        //   ?.patchValue(record[0].ShiftStart);
        // this.oeeDashboardForm.get('dateEnd')?.patchValue(endDT);        

        this.oeeDashboardForm
          .get('dateStart')
          ?.patchValue(record[0].ShiftStart);


          const lastshifttDT = new Date();
          lastshifttDT.setDate(lastshifttDT.getDate() - 1);

          const key = {
            PUID: this.oeeDashboardForm.value.unit,
            Date: (lastshifttDT),
          };
      
          this.crewService.GetCrewScheduleData(key).subscribe((res: any) => {
            this.crewScheduleList = res.CrewScheduleList;
            const record = this.crewScheduleList;

            if (record.length>1)
            {
              this.oeeDashboardForm.get('dateEnd')?.patchValue(record[1].ShiftEnd);
            }

          });
        

        this.key = {
          dtStartDate: this.oeeDashboardForm.value.dateStart,
          dtEndDate: this.oeeDashboardForm.value.dateEnd,
          GroupId: this.oeeDashboardForm.value.UserGroup1,
          PlantId: this.oeeDashboardForm.value.UserPlant1,
          UnitId: this.oeeDashboardForm.value.unit,
          LineId: this.oeeDashboardForm.value.line,
          shift: '*',
        };
        this.getOeeDashboard();
      } else {
        this.key = {
          dtStartDate: this.oeeDashboardForm.value.dateStart,
          dtEndDate: this.oeeDashboardForm.value.dateEnd,
          GroupId: this.oeeDashboardForm.value.UserGroup1,
          PlantId: this.oeeDashboardForm.value.UserPlant1,
          UnitId: this.oeeDashboardForm.value.unit,
          LineId: this.oeeDashboardForm.value.line,
          shift: '*',
        };
        this.getOeeDashboard();
      }
    });
  }

  getOeeDashboard() {
    this.resetOEE();
    this.spinner.show();
    this.productivityservice.getOEE(this.key).subscribe(
      (data: any) => {
        this.OeeDashboardData = data;
        this.spinner.hide();
        this.setData();
      },
      (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    );
  }

  setData() {
    this.capacityUtilizationAnalysis.progress =
      this.OeeDashboardData.CUPerc.toFixed(0);
    this.oeeAnalysis.progress =
      this.OeeDashboardData.AvgOee >= 100
        ? this.OeeDashboardData.AvgOee.toFixed(0)
        : this.OeeDashboardData.AvgOee.toFixed(0);
    this.availabilityAnalysis.progress =
      this.OeeDashboardData.AvgAvailability >= 100
        ? this.OeeDashboardData.AvgAvailability.toFixed(0)
        : this.OeeDashboardData.AvgAvailability.toFixed(0);
    this.performanceAnalysis.progress =
      this.OeeDashboardData.AvgPerformance >= 100
        ? this.OeeDashboardData.AvgPerformance.toFixed(0)
        : this.OeeDashboardData.AvgPerformance.toFixed(0);
    this.qualityAnalysis.progress =
      this.OeeDashboardData.AvgQualityRate >= 100
        ? this.OeeDashboardData.AvgQualityRate.toFixed(0)
        : this.OeeDashboardData.AvgQualityRate.toFixed(0);
    this.setColorCoding();
    this.GrossProduce = this.OeeDashboardData.GrossProduce.toFixed(2);
    this.AvailableHours = this.nFormatter(
      this.OeeDashboardData.AvailableHours,
      2
    );
    this.PlannedHours = this.nFormatter(this.OeeDashboardData.PlannedHours, 2);
    this.RunningHourse = this.nFormatter(
      this.OeeDashboardData.RunningHourse,
      2
    );
    this.PlannedDowntime = this.nFormatter(
      this.OeeDashboardData.PlannedDowntime,
      2
    );
    this.UnplannedDowntime = this.nFormatter(
      this.OeeDashboardData.UnplannedDowntime,
      2
    );
    this.totalPlannedDowntime =
      this.PlannedDowntime * 1 + this.UnplannedDowntime * 1;
    this.Waste = this.OeeDashboardData.Waste.toFixed(2);
    this.ShutdownHours = this.nFormatter(
      this.OeeDashboardData.ShutdownHours,
      2
    );
    this.idealProduction = this.OeeDashboardData.IdealProduce.toFixed(2);
    this.grossProduction = this.OeeDashboardData.GrossProduce.toFixed(2);
    this.netProduction = this.OeeDashboardData.NetProduce.toFixed(2);
    this.wasteKG = this.OeeDashboardData.WasteKg.toFixed(2);
    this.rowData = this.OeeDashboardData.dtDetails;
    if (this.OeeDashboardData.dtMonthlyOee !== null) {
      this.drawMonthlyOee(this.OeeDashboardData.dtMonthlyOee);
    } else {
      this.monthlyOeeData.length = 0;
      this.monthlyOeeLabel.length = 0;
    }
    if (this.OeeDashboardData.dtMonthlyGrossProduce !== null) {
      this.drawMonthlyOutput(this.OeeDashboardData.dtMonthlyGrossProduce);
    } else {
      this.monthlyOutputData.length = 0;
      this.monthlyOutputLabel.length = 0;
    }
    this.drawMonthlyOutputLoss(this.OeeDashboardData);
    this.monthlyOEEDrillDown();
  }

  resetOEE(): void {
    this.capacityUtilizationAnalysis.progress = 0;
    this.oeeAnalysis.progress = 0;
    this.availabilityAnalysis.progress = 0;
    this.performanceAnalysis.progress = 0;
    this.qualityAnalysis.progress = 0;
    this.GrossProduce = 0;
    this.AvailableHours = 0;
    this.PlannedHours = 0;
    this.RunningHourse = 0;
    this.Waste = 0;
    this.ShutdownHours = 0;
    this.idealProduction = 0;
    this.grossProduction = 0;
    this.netProduction = 0;
    this.wasteKG = 0;
  }
  makeData() {
    this.key = {
      dtStartDate: this.oeeDashboardForm.value.dateStart,
      dtEndDate: this.oeeDashboardForm.value.dateEnd,
      GroupId: this.oeeDashboardForm.value.UserGroup1,
      PlantId: this.oeeDashboardForm.value.UserPlant1,
      UnitId: this.oeeDashboardForm.value.unit,
      LineId: this.oeeDashboardForm.value.line,
      shift: '*',
    };
  }

  //=================================================================== Monthly OEE chart =======================================================//

  drawMonthlyOee(data: any) {
    let dtLabel: any[] = new Array();
    let dtData: any[] = new Array();
    if (data !== null) {
      data.forEach((element: any) => {
        dtLabel.push(element.Month);
        dtData.push([element.Month, parseFloat(element.AvgMonthlyOEE)]);
      });
    }
    this.options = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: dtLabel,
      },
      yAxis: {
        min: 0,
        max: 100,
        labels: {
          format: '{value}%',
        },
        title: {
          text: 'OEE Trend',
        },
      },
      tooltip: {
        pointFormat: '<b>{point.y:,.2f}</b>',
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'OEE Trend',
          type: 'column',
          data: dtData,
        },
      ],
    };
    let chart = new Chart(this.options);
    this.chartMonthlyOeeTrend = chart;
  }

  //==================================================== Monthly Output chart==========================================//

  drawMonthlyOutput(data: any) {
    let dtLabel: any[] = new Array();
    let dtData: any[] = new Array();
    if (data !== null) {
      data.forEach((element: any) => {
        dtLabel.push(element.Month);
        dtData.push([element.Month, parseFloat(element.SumGrossProduce)]);
      });
    }
    this.options = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: dtLabel,
      },
      yAxis: {
        title: {
          text: 'Volume Output',
        },
        labels: {
          formatter: function () {
            return Highcharts.numberFormat(
              parseInt(this.value.toString()),
              0,
              '',
              ''
            );
          },
          autoRotationLimit: 0,
        },
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: '<b>{point.y:,.2f}</b>',
      },
      series: [
        {
          name: 'Volume Output',
          type: 'column',
          data: dtData,
        },
      ],
    };
    let chart = new Chart(this.options);
    this.chartMonthlyOutput = chart;
  }

  //============================================= Monthly Output loss waterfall chart ===============================//

  drawMonthlyOutputLoss(response: any) {
    this.chartOutputLossData.length = 0;
    this.chartOutputLossData.push({
      label: 'Good Output',
      value: response.GoodsOutput ? response.GoodsOutput : 0,
    });
    this.chartOutputLossData.push({
      label: 'Waste',
      value: response.WasteOutput ? response.WasteOutput : 0,
    });
    this.chartOutputLossData.push({
      label: 'Speed Loss',
      value: response.SpeedLossOutput ? response.SpeedLossOutput : 0,
    });
    this.chartOutputLossData.push({
      label: 'Shutdown loss',
      value: response.ShutDownOutput ? response.ShutDownOutput : 0,
    });
    this.chartOutputLossData.push({
      label: 'DownTime loss',
      value: response.DowntimeOutput ? response.DowntimeOutput : 0,
    });
    this.waterfallMonthlyOutputLoss();
  }

  waterfallMonthlyOutputLoss() {
    let wasteData: any[] = new Array();
    this.chartOutputLossData.forEach((element) => {
      wasteData.push({ name: element.label, y: element.value });
    });
    wasteData.push({
      name: 'Total',
      isIntermediateSum: true,
      color: '#0f0fd1',
    });

    this.options = {
      chart: {
        type: 'waterfall',
        inverted: false,
      },

      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        type: 'category',
      },

      yAxis: {
        title: {
          text: 'Output Losses',
        },
        labels: {
          formatter: function () {
            return Highcharts.numberFormat(
              parseInt(this.value.toString()),
              0,
              '',
              ''
            );
          },
          autoRotationLimit: 0,
        },
      },

      legend: {
        enabled: false,
      },

      tooltip: {
        pointFormat: '<b>{point.y:,.2f}</b>',
      },
      plotOptions: {
        series: {
          borderColor: '',
        },
      },
      series: [
        {
          type: 'waterfall',
          name: 'Output Losses',
          color: '#5adb90',
          data: wasteData,
        },
      ],
    };
    let chart = new Chart(this.options);
    this.chartOutputLossWaterfall = chart;
  }

  nFormatter(num: any, digits: any) {
    if (digits === undefined) {
      digits = 1;
    }
    var si = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: ' K' },
      { value: 1e6, symbol: ' M' },
      { value: 1e9, symbol: ' G' },
      { value: 1e12, symbol: ' T' },
      { value: 1e15, symbol: ' P' },
      { value: 1e18, symbol: ' E' },
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }
    return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
  }

  //=============================================================== Color Coding ==========================================//

  setColorCoding() {
    //OEE
    if (this.oeeAnalysis.progress > 0 && this.oeeAnalysis.progress <= 20) {
      this.oeeAnalysis.color = '#fa1f0f';
    } else if (
      this.oeeAnalysis.progress > 20 &&
      this.oeeAnalysis.progress <= 50
    ) {
      this.oeeAnalysis.color = '#fae311';
    } else if (
      this.oeeAnalysis.progress > 50 &&
      this.oeeAnalysis.progress <= 70
    ) {
      this.oeeAnalysis.color = '#fc7005';
    } else if (this.oeeAnalysis.progress > 70) {
      this.oeeAnalysis.color = '#069420';
    }
    //CU
    if (
      this.capacityUtilizationAnalysis.progress > 0 &&
      this.capacityUtilizationAnalysis.progress <= 20
    ) {
      this.capacityUtilizationAnalysis.color = '#fa1f0f';
    } else if (
      this.capacityUtilizationAnalysis.progress > 20 &&
      this.capacityUtilizationAnalysis.progress <= 50
    ) {
      this.capacityUtilizationAnalysis.color = '#fae311';
    } else if (
      this.capacityUtilizationAnalysis.progress > 50 &&
      this.capacityUtilizationAnalysis.progress <= 70
    ) {
      this.capacityUtilizationAnalysis.color = '#fc7005';
    } else if (this.capacityUtilizationAnalysis.progress > 70) {
      this.capacityUtilizationAnalysis.color = '#069420';
    }
    // Availability
    if (
      this.availabilityAnalysis.progress > 0 &&
      this.availabilityAnalysis.progress <= 20
    ) {
      this.availabilityAnalysis.color = '#fa1f0f';
    } else if (
      this.availabilityAnalysis.progress > 20 &&
      this.availabilityAnalysis.progress <= 50
    ) {
      this.availabilityAnalysis.color = '#fae311';
    } else if (
      this.availabilityAnalysis.progress > 50 &&
      this.availabilityAnalysis.progress <= 70
    ) {
      this.availabilityAnalysis.color = '#fc7005';
    } else if (this.availabilityAnalysis.progress > 70) {
      this.availabilityAnalysis.color = '#069420';
    }
    //performanceAnalysis
    if (
      this.performanceAnalysis.progress > 0 &&
      this.performanceAnalysis.progress <= 20
    ) {
      this.performanceAnalysis.color = '#fa1f0f';
    } else if (
      this.performanceAnalysis.progress > 20 &&
      this.performanceAnalysis.progress <= 50
    ) {
      this.performanceAnalysis.color = '#fae311';
    } else if (
      this.performanceAnalysis.progress > 50 &&
      this.performanceAnalysis.progress <= 70
    ) {
      this.performanceAnalysis.color = '#fc7005';
    } else if (this.performanceAnalysis.progress > 70) {
      this.performanceAnalysis.color = '#069420';
    }
    //qualityAnalysis
    if (
      this.qualityAnalysis.progress > 0 &&
      this.qualityAnalysis.progress <= 20
    ) {
      this.qualityAnalysis.color = '#fa1f0f';
    } else if (
      this.qualityAnalysis.progress > 20 &&
      this.qualityAnalysis.progress <= 50
    ) {
      this.qualityAnalysis.color = '#fae311';
    } else if (
      this.qualityAnalysis.progress > 50 &&
      this.qualityAnalysis.progress <= 70
    ) {
      this.qualityAnalysis.color = '#fc7005';
    } else if (this.qualityAnalysis.progress > 70) {
      this.qualityAnalysis.color = '#069420';
    }
  }

  //========================================================= AG Grid ====================================================//

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  excelExport() {
    this.gridApi.exportDataAsExcel();
  }
  csvExport() {
    this.gridApi.exportDataAsCsv();
  }

  //============================================================  Drill Down ===========================================================//
  monthlyOEEDrillDown() {
    const parent = [];
    let child = [];
    const drillData = [];

    this.OeeDashboardData.dtDrillDownChartData.forEach(value => {
      this.OeeDashboardData.dtDrillDownChartData.forEach(val => {
        if (value.ParentId === 0 && value.id === val.ParentId) {
          const data = {
            name: value.Name,
            y: value.Perc,
            drilldown: val.id,
            Minutes: value.Value,
            Occurence: value.Occurrances
          }
          parent.push(data);
        }

      })
    })

    this.OeeDashboardData.dtDrillDownChartData.forEach((element) => {
      this.OeeDashboardData.dtDrillDownChartData.forEach(val => {
        if (element.id === val.ParentId && val.treeId === 0 ) {
          const dataChild = {
            name: element.Name,
            y: element.Perc,
            drilldown: val.id,
            Minutes: element.Value,
            Occurence: element.Occurrances
          }
          child.push(dataChild);
        }
      })
      const keyData = {
        id: element.id,
        name: element.Name,
        type: 'column',
        data: child.length > 0 ? child : [{ name: element.Name, y: element.Perc, drilldown: '' , Minutes: element.Value, Occurence: element.Occurrances}]
      }
      drillData.push(keyData);
      child = [];

    })

    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'category',
      },
      yAxis: {
        labels: {
          format: '{value}%',
        },
        title: {
          text: 'OEE Looses',
        },
      },
      plotOptions: {
        series: {
          turboThreshold: 1000000,
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        valueDecimals: 2,
        formatter: function () {
          return '<b>' + this.point.options.name +' :' + this.point.options.y + '</b></br><b>' + 'Duration (mins)' +' :' + this.point.options.Minutes + '</b></br><b>' + 'Occurence' +' :' + this.point.Occurence +'</b>'
        }
      },
      series: [
        {
          name: 'Main',
          type: 'column',
          colorByPoint: true,
          data: parent,
        },
      ],
      drilldown: {
        allowPointDrilldown: false,
        activeAxisLabelStyle: {
          textDecoration: 'none',
          fontStyle: 'normal',
        },
        activeDataLabelStyle: {
          textDecoration: 'none',
          fontStyle: 'normal',
        },
        series: drillData.slice(1),
        drillUpButton: {
          relativeTo: 'spacingBox',
          position: {
            y: 0,
            x: 0,
          },
          theme: {
            fill: 'white',
            'stroke-width': 1,
            stroke: 'blue',
            r: 0,
            states: {
              hover: {
                fill: '#ffffff',
              },
              select: {
                stroke: '#039',
                fill: '#0f02fa',
              },
            },
          },
        },
      },
    };
    let chart = new Chart(this.options);
    this.chartMonthlyOeeDrill = chart;
  }
  showPhase(event: any) {
    this.activeButton = event;
  }

  navigateToQualityGridAnalysis() {
    const filter = this.oeeDashboardForm.value;
    const obj = {
      fromDate: filter.dateStart,
      toDate: new Date(),
      UnitId: filter.unit,
      PTId: filter.UserPlant1,
      GroupId: filter.UserGroup1,
      LineId: filter.line,
      hasParams: true,
    };
    localStorage.setItem('QualityGridAnalysis', JSON.stringify(obj));
    this.router.navigate([]).then(result => {
      window.open(`/quality/QualityGradeAnalysis`, '_blank');
    });
  }

  navigateToParetoDashboard() {
    const filter = this.oeeDashboardForm.value;
    const obj = {
      dateStart: filter.dateStart,
      dateEnd: new Date(),
      UnitId: filter.unit,
      UserPlant1: filter.UserPlant1,
      UserGroup1: filter.UserGroup1,
      line: filter.line,
      hasParams: true,
    };
    localStorage.setItem('ParetoDashboard', JSON.stringify(obj));
    this.router.navigate([]).then(result => {
      window.open(`/Dashboard/Pareto`, '_blank');
    });
  }
}